import { useContext, useEffect } from 'react';
import './LoadIndicator.scss';
import StyleContext, { StyleContextData } from '../style/context.ts';

export type LoadIndicatorContentProps = {
	color?: string;
};

const LoadIndicatorContent: React.FC<LoadIndicatorContentProps> = ({
	color = '#000000',
}) => {
	const { changeCSSVariables } =
		useContext<StyleContextData>(StyleContext) || {};

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		changeCSSVariables('primary-action__color', color);
	}, [color]);

	return (
		<svg className="aux-progress-ring" aria-hidden="true" viewBox="0 0 80 80">
			<circle
				className="aux-progress-ring__background-circle"
				r="38"
				cy="40"
				cx="40"
			></circle>
			<circle
				className="aux-progress-ring__circle"
				r="38"
				cy="40"
				cx="40"
			></circle>
		</svg>
	);
};

export default LoadIndicatorContent;
